import React from 'react';
import { SurveyQuestionType } from 'freemium-survey-components';

type FormFieldProps = {
  questionAnswer?: any;
  question?: SurveyQuestionType;
  respondedQuestionAnswerLabels?: string[];
};

export const FormFieldResponse = ({
  questionAnswer,
  question,
  respondedQuestionAnswerLabels,
}: FormFieldProps) => {
  return (
    <table className="form-field">
      {respondedQuestionAnswerLabels?.map((field, idx) => {
        return (
          <tr key={`${field}_${idx}`}>
            <td className="label">{field}</td>
            <td className="label" style={{ padding: '0 15px 0 15px' }}>
              :
            </td>
            <td className="description">{questionAnswer?.[field]}</td>
          </tr>
        );
      })}
    </table>
  );
};
